module.exports = __webpack_public_path__ + "static/media/eating-lunch-office.31bf6e0f.svg";